import './DatasetNameForm.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FormAlert } from '../../../components/FormAlert';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';

interface IDatasetNameFormProps {
  name: string;
  description: string;
  nameStatus: InputStatus;
  externalStatus: InputStatus;
  author: string;
  termsOfUse: string;
  onNameChange: (name: string) => Promise<void>;
  onDescriptionChange: (name: string) => void;
  onAuthorChange: (name: string) => void;
  onTermsOfUseChange: (name: string) => void;
}

export const DatasetNameForm = observer((props: IDatasetNameFormProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='dataset-name-form'>
      <FormAlert errors={props.externalStatus} />
      <ValidatedTextInput
        id='dataset-name-input'
        type={'text'}
        maxLength={200}
        value={props.name}
        placeholder={t('type_dataset_name')}
        onChange={(val) => {
          void props.onNameChange(val);
        }}
        isValid={props.nameStatus.isValid}
        feedbacks={props.nameStatus.errorCodes}
      />
      <ValidatedTextInput
        id='dataset-description-input'
        type={'text'}
        maxLength={500}
        value={props.description}
        placeholder={t('type_dataset_description')}
        onChange={props.onDescriptionChange}
        isValid={undefined}
      />
      <ValidatedTextInput
        id='dataset-author-input'
        type={'text'}
        maxLength={500}
        value={props.author}
        placeholder={t('type_dataset_author')}
        onChange={props.onAuthorChange}
        isValid={undefined}
      />
      <ValidatedTextInput
        id='dataset-termsOfUse-input'
        type={'text'}
        maxLength={500}
        value={props.termsOfUse}
        placeholder={t('type_dataset_terms_of_use')}
        onChange={props.onTermsOfUseChange}
        isValid={undefined}
      />
    </div>
  );
});
